import useAxios from '../api/useAxios';
import axios from 'axios'
import useAuth from './useAuth';
import qs from 'qs';

const useRefreshToken = (refreshToken) => {
    const { setAuth } = useAuth();
    var data = qs.stringify({
        'grant_type': 'refresh_token',
        'refresh_token': refreshToken
    });

    let config = {
        method: 'post',
        url: 'http://localhost:9101/oauth/token',
        withCredentials: true,
        headers: { 
            'Authorization': 'Basic dGVzdC1jbGllbnQtaWQ6dGVzdC1jbGllbnQtc2VjcmV0', 
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        data
    };
    

    const refresh = async () => {
        // const response = await axios.get('/refresh', {
        //     withCredentials: true
        // });
          
        axios(config).then(function (response) {
            setAuth(prev => {
                return { ...prev, accessToken: response.data.access_token }
            });
            return response.data.access_token;
        }).catch(function (error) {
            console.log(error);
        });
        
    }
    return refresh;
};

export default useRefreshToken;